import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function UserProfile() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <div className="flex p-4 @container">
      <div className="flex w-full flex-col gap-4 items-center">
        <div className="flex gap-4 flex-col items-center">
          {user.profileImage ? (
            <div
              className="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-16 h-16 md:w-32 md:h-32"
              style={{ backgroundImage: `url(${user.profileImage})` }}
            />
          ) : (
            <div className="bg-primary rounded-full w-16 h-16 md:w-32 md:h-32 flex items-center justify-center text-white text-2xl md:text-4xl font-bold">
              {user.fullName.charAt(0)}
            </div>
          )}
          <div className="flex flex-col items-center justify-center">
            <p className="text-white text-[22px] font-bold leading-tight tracking-[-0.015em] text-center">
              {user.fullName}
            </p>
            <p className="text-text-secondary text-base font-normal leading-normal text-center">
              Student
            </p>
            {user.joinedYear && (
              <p className="text-text-secondary text-base font-normal leading-normal text-center">
                Joined in {user.joinedYear}
              </p>
            )}

            {/* Analytics Link - Only show for admin users */}
            {user.isAdmin && (
              <button
                onClick={() => navigate('/admin/analytics')}
                className="mt-2 text-indigo-400 hover:text-indigo-300 text-sm font-medium transition-colors flex items-center gap-1"
              >
                <span>📊</span>
                <span>View Analytics</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
